let store;

if (!__DEV__) {
  store = require("./configureStore.build").default;
} else {
  store = require("./configureStore.dev").default;
}

export default store;



// WEBPACK FOOTER //
// ./src/app/store/configureStore.js